import { supabaseClient } from 'supabase'

type Advertiser = {
  id: string
  name: string
  category: string
  contact_email: string
  contact_phone?: string | null
  logo_url?: string | null
  created_at: string
  updated_at: string
}

export type QueryAdvertisersParams = {
  name?: string
  category?: string
  page?: number
  perPage?: number
}

export const queryAdvertisers = async ({
  name,
  category,
  page,
  perPage,
}: QueryAdvertisersParams = {}) => {
  let baseQuery = supabaseClient.from('advertisers').select('*', {
    count: 'exact',
  })

  if (name) {
    baseQuery = baseQuery.ilike('name', `%${name}%`)
  }

  if (category) {
    baseQuery = baseQuery.ilike('category', `%${category}%`)
  }

  baseQuery = baseQuery.order('name')

  if (page && perPage) {
    baseQuery = baseQuery.range(
      (page - 1) * perPage,
      (page - 1) * perPage + perPage - 1
    )
  }

  const { data, count, error } = await baseQuery

  if (error) {
    throw error
  }

  return {
    advertisers: data as Advertiser[],
    count: count || 0
  }
}